import './index.css'
import { Link } from 'react-router-dom'

export default function PhotoStory() {
  return (
    <div className={'photoStory'}>
      <h1>Foto Archivio</h1>
      <p>Un archivio di immagini per mantenere una memoria  storica dei nostri luoghi , genti e tradizioni.</p>

      <h3>I nostri comuni</h3>
      <Link to="/ziano">
        <div className={'photoStory--card'}>
          <img src={'https://www.valtidoneluretta.com/wp-content/uploads/2018/03/IMG_7197-1181x430.jpg'} />
          <h2>Ziano Piacentino</h2>
        </div>
      </Link>
    </div>
  )
}
